import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTrackingService } from "@/Services/TrackingService";

// Height of the dashboard's nav + footer chrome, subtracted so the card centres
// in the visible area rather than the full viewport.
const CHROME_HEIGHT = "calc(100vh - 200px)";

export function LookUpTrackingScreen() {
  const trackingService = useTrackingService();
  const [proBolNumber, setProBolNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState<ErrorMessageType>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  async function onLookup() {
    if (loading) {
      return;
    }
    setLoading(true);
    setErrorMessage(undefined);
    const trackingId =
      await trackingService.getTrackingIdForProBolNumber(proBolNumber);

    if (trackingId === undefined) {
      setErrorMessage("Sorry, this Pro/Bol Number was not found");
    } else {
      navigate(`/t?tId=${trackingId}`);
    }
    setLoading(false);
  }

  return (
    <Center minHeight={CHROME_HEIGHT} maxWidth={440}>
      <Panel
        title="Look up tracking by Pro or BOL Number"
        description="If you've been given a FreightSimple Pro/BOL Number, you can enter it here to get tracking details."
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onLookup();
          }}
          noValidate
        >
          <Stack gap={4}>
            <ShowFormErrors show={errorMessage !== undefined}>
              <FormItem error={errorMessage} fillWidth>
                <TextInput
                  value={proBolNumber}
                  onChange={(e) => setProBolNumber(e.target.value)}
                  placeholder="Enter Pro/BOL Number"
                  width="full"
                />
              </FormItem>
            </ShowFormErrors>
            <Button
              primary
              fullWidth
              onClick={onLookup}
              disabled={proBolNumber.length < 6}
              disabledMessage="Enter at least 6 characters of a PRO or BOL number"
              loading={loading}
            >
              Lookup
            </Button>
          </Stack>
        </form>
      </Panel>
    </Center>
  );
}
